export enum ClientConstants {
  PREMIALAB = 'Premialab',
  HSBC = 'HSBC',
  BARCLAYS = 'Barclays',
  BOFA = 'BofA',
  RBC = 'RBC',
  SOCGEN = 'SocGen',
}
